import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'TemplatesService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  '$window',
  'CartService'
];

class TemplatesController {
  constructor($scope, TemplatesService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window,CartService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.TemplatesService = TemplatesService;
    this.Pagination = Pagination;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.$window = $window;
    this.CartService = CartService;
    /**
     Text for searching orders
     @property searchText
     @type String
     @default ''
     */
    this.searchText = '';

    /**
     Sort type by order attribute
     @property sortType
     @type String
     @default 'name'
     */
    this.sortType = 'fecha_creacion';

    /**
     Orders sort order. Use true for reverse order
     @property sortReverse
     @type boolean
     @default false
     */
    this.sortReverse = true;

    this.userCartTemplates = [];
    this.loadingUserCartTemplates = false;
    this.loadedUserCartTemplates = false;
    this.errorloadingUserCartTemplates = false;
    this.itemsPerPage = 10;
    this.cartTemplateId = 0;
  }

  $onInit() {
    this.getUserCartTemplates();
  }

  deleteCartTemplate(cartTemplate) {
    cartTemplate.loading = true;
    cartTemplate.response = {};

    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    }
    catch (e) {
    }
    this.TemplatesService.deleteCartTemplate({
      'cartTemplateId': cartTemplate.id,
      'userId': userId,
      'sellerId': sellerId,
      'origin':'B2B'
    }).then(response => {
      cartTemplate.loading = false;
      cartTemplate.response = response;

      if (!response.error) {
        this.$timeout(() => {
          this.$state.reload()
        }, 1000);
      }
    }).catch(reason => {
      cartTemplate.loading = false;
      cartTemplate.response.error = true;
      cartTemplate.response.message = 'Ha ocurrido un error interno. Por favor contacte al administrador del sistema.';
    });
  }

  showSort(value) {
    this.sort = value;
  }

  getUserCartTemplates() {
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    }
    catch (e) {
    }

    this.loadingUserCartTemplates = true;
    this.loadedUserCartTemplates = false;
    this.errorloadingUserCartTemplates = false;

    this.TemplatesService.getUserCartTemplates({ 'userId': userId, 'sellerId': sellerId }).then(response => {
      this.loadingUserCartTemplates = false;
      this.loadedUserCartTemplates = true;
      this.errorloadingUserCartTemplates = false;

      this.pagination = this.Pagination.getNew(40);
      this.userCartTemplates = response.data;

      if (this.userCartTemplates.templates.length > 0) {
        this.pagination.numPages = Math.ceil(this.userCartTemplates.templates.length / this.pagination.perPage);
      }
    }).catch(reason => {
      this.loadingUserCartTemplates = false;
      this.loadedUserCartTemplates = true;
      this.errorloadingUserCartTemplates = true;
    });
  }

  loadCartTemplateToCurrentCart(cartTemplate) {
    cartTemplate.duplicate = {};

    cartTemplate.duplicate.duplicating = true;
    cartTemplate.duplicate.duplicated = false;
    cartTemplate.duplicate.message = '';
    this.loadingUserCartTemplates = true;
    this.cartTemplateId = cartTemplate.id;
    let cartId = this.SessionService.get('cartId') || '';
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }
    this.TemplatesService.duplicateCartTemplate({ 'cartTemplateId': this.cartTemplateId, 'cartId': cartId ,'origin':'B2B','userId': userId}).then(response => {
      // this.$timeout(() => {
        if (!response.error) {
          this.loadingUserCartTemplates = false;
          cartTemplate.duplicate.duplicating = false;
          cartTemplate.duplicate.duplicated = true;

          cartTemplate.duplicate.error = false;
          cartTemplate.duplicate.message = response.message;

          this.SessionService.put('cartId', response.cartId);
          if (response.validaVolumenCompra) {
            this.SharedService.verifyVolumePurchaseBasket({ 'cartId': response.cartId }).then(volumenResponse => {
              if (!volumenResponse.error) {
                if (!volumenResponse.pesoValidoBodega) {
                  let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
                  let idUsuario = this.shCtrl.globals.currentUser.userId;
                  this.cambiarSucursalVolumenItems(response.cartId, idCiudad, idUsuario);
                } else {
                  if (cartTemplate.duplicate.message) {
                    let options = {
                      title: 'Productos cargados correctamente',
                      isHtml: true,
                      content: cartTemplate.duplicate.message,
                      size: '',
                      textAction: 'Cerrar'
                    };
                    this.messageResponseDuplicate(options);
                  }
                  this.$state.go('home.cart', {
                    from: 'fromTemplates'
                  });
                }
              }
            });
          } else {
            if (cartTemplate.duplicate.message) {
              let options = {
                title: 'Productos cargados correctamente',
                isHtml: true,
                content: cartTemplate.duplicate.message,
                size: '',
                textAction: 'Cerrar'
              };
              this.messageResponseDuplicate(options);
            }
            this.$state.go('home.cart', {
              from: 'fromTemplates'
            });
          }
        }
        else {
          this.loadingUserCartTemplates = false;
          cartTemplate.duplicate.duplicating = false;
          cartTemplate.duplicate.duplicated = false;
          cartTemplate.duplicate.error = true;
          cartTemplate.duplicate.message = response.message;
          let mensaje = cartTemplate.duplicate.message;
          let options = {
            title: 'Plantilla unificada',
            isHtml: true,
            content: mensaje,
            size: '',
            showBottonCancel: true,
            textActionCancel: 'Cancelar',
            textAction: 'Aceptar'
          };
          return this.messageResponse(options);

        }
      // }, 1000);
    }).catch(reason => {
      cartTemplate.duplicate.duplicating = false;
      cartTemplate.duplicate.duplicated = false;
      cartTemplate.duplicate.error = true;
      cartTemplate.duplicate.message = 'Ha ocurrido un error al duplicar el pedido.';
    });
  }

  setCurrentCartTemplate(template) {
    this.currentCartTemplate = template;
  }

  messageResponse(options) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      this.duplicateCartTemplateStock();
    }).catch(() => {
    });
  }

  messageResponseDuplicate(options) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
    }).catch(() => {
    });
  }

  setPagination(itemsPerPage) {
    this.itemsPerPage = itemsPerPage;
    this.pagination = this.Pagination.getNew(this.itemsPerPage);
    this.pagination.numPages = Math.ceil(this.userOrders.ordersQuotes.length / this.pagination.perPage);
  }

  duplicateCartTemplateStock() {
    let cartId = this.SessionService.get('cartId') || '';
    this.loadingUserCartTemplates = true;
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }
    this.TemplatesService.duplicateCartTemplateWithStock({ 'cartTemplateId': this.cartTemplateId, 'cartId': cartId ,'origin':'B2B','userId': userId}).then(response => {
      // this.$timeout(() => {
        if (!response.error) {
          this.SessionService.put('cartId', response.cartId);
          this.loadingUserCartTemplates = false;
          if (response.message) {
            let options = {
              title: response.modalTitle,
              isHtml: true,
              content: response.message,
              size: '',
              textAction: 'Cerrar'
            };
            this.messageResponseDuplicate(options);
          }
          this.$state.go('home.cart');
        }
      // }, 1000);
    }).catch(reason => {
      this.loadingUserCartTemplates = false;
      console.log('Ocurrio un error al realizar la carga del carrito');
    });
  }

  cambiarSucursalVolumenItems(cartId, idCiudad, idUsuario) {
    this.CartService.getShippingMode(cartId).then(response => {
      if (response.modalidad) {
        this.setSucursalesPorModalidad(response, cartId, idCiudad, idUsuario);
      } else {
        this.obtenerSucursalSecundaria(cartId, idCiudad, idUsuario);
      }
    });
  }

  setSucursalesPorModalidad(response, cartId, idCiudad, idUsuario) {
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    let tipoModalidad = response.modalidad.tipo_modalidad;
    // Si la modalidad es recoge
    if (tipoModalidad == 0) {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
          if (this.branchUserB2B != idSucursalSecundaria) {
            this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, cartId);
          } else {
            this.$state.go('home.cart');
            this.$timeout(() => {
              this.$state.reload();
            }, 500);
            this.ok();
            let mesaggeChange = this.shCtrl.globalParams.cmsInfo.MENSAJE_CAMBIO_SUCURSAL;
            if (mesaggeChange !== '') {
              mesaggeChange = mesaggeChange;
              let optionsMessage = {
                title: 'Notificación',
                isHtml: true,
                content: mesaggeChange,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(optionsMessage);
            }
          }
        }
      });
      this.CartService.updateDateCart(cartId).then(response => {
        return response;
      });
      // Si es a domicilio
    } else {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        let idCiudad = response.listaSucursales[0].ciudad_id;

        if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
          this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
            let aplicaServicioDescargue = response.aplicaServicioDescargue;
            if (idSucursalSecundaria != null) {
              if (this.branchUserB2B != idSucursalSecundaria) {
                this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, cartId);
              } else {
                this.$state.go('home.cart');
                this.$timeout(() => {
                  this.$state.reload();
                }, 500);
                this.ok();
                let mesaggeChange = this.shCtrl.globalParams.cmsInfo.MENSAJE_CAMBIO_SUCURSAL;
                if (mesaggeChange !== '') {
                  mesaggeChange = mesaggeChange;
                  let optionsMessage = {
                    title: 'Notificación',
                    isHtml: true,
                    content: mesaggeChange,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                  };
                  return this.messageResponse(optionsMessage);
                }
              }
            }
          });
        }
      });
    }
  }

  setSucursalSecundariaRecogeEntrega(idSucursal, userId, cartId) {

    let mensajeCambioSucursal = '';
    let mensajeCambioHorarioBodega = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
      allMessage.push(mensajeCambioSucursal);
      allMessage.push(mensajeCambioHorarioBodega);

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.$rootScope.$broadcast('actualizarHeader', response.branch);

          this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
            if (!response.error) {
              let currentClient = this.SessionService.get('currentClient');
              let sucursalId = currentClient.operatingCenter.id;
              this.CartService.verifyBranchLock(sucursalId).then(response => {
                if (!response.error) {
                  if (response.bloqueoSucursal) {
                    let validacionRetiroMensaje = this.shCtrl.ngAuthSettings.site.info.company.validacionRetiroTiendaMensaje;
                   // this.modalidadRecoge = false;

                    let messageBloqueoRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO
                    allMessage.push(messageBloqueoRetiro);

                    if(validacionRetiroMensaje){
                      let cartId = this.SessionService.get('cartId') || '';
                      let userId = this.shCtrl.globals.currentUser.userId;
                      this.CartService.getMaximumMainVolume(cartId,userId).then(responseMaximun => {
                        if(!responseMaximun.error){
                          let messageRetiro = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_MOSTRAR_CANTIDAD_MAXIMA_OPL;
                          messageRetiro = messageRetiro.replace("#capacidad_maxima_bodega_anterior#", responseMaximun.pesoMaximoBodega)
                          allMessage.push(messageRetiro);
                          if (allMessage !== null) {
                            this.$state.go('home.cart');
                            this.$timeout(() => {
                              this.$state.reload();
                            }, 500);
                            this.showModalAllMessage(allMessage);
                          }
                        }
                      });
                    } else{
                      if (allMessage !== null) {
                        this.$state.go('home.cart');
                        this.$timeout(() => {
                          this.$state.reload();
                        }, 500);
                        this.showModalAllMessage(allMessage);
                      }
                    }
                  } else {
                    if (allMessage !== null) {
                      this.$state.go('home.cart');
                      this.$timeout(() => {
                        this.$state.reload();
                      }, 500);
                      this.showModalAllMessage(allMessage);
                    }
                  }
                }
              });
            }
          });
        } catch (e) {
        }

      } else {
        console.log('Ocurrio un error al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue, cartId) {

    let mensajeCambioSucursal = '';
    let mensajeDestinoNoDisponilble = '';
    let mensajeCambioPromesa = '';
    let allMessage = [];

    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
      allMessage.push(mensajeCambioSucursal);
      allMessage.push(mensajeCambioPromesa);

      if (!aplicaServicioDescargue) {
        this.servicioDescargue = aplicaServicioDescargue;
        mensajeDestinoNoDisponilble = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
        allMessage.push(mensajeDestinoNoDisponilble);
      }

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);
          this.$rootScope.$broadcast('actualizarHeader', response.branch);

          this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
            if (!response.error) {

              if (allMessage !== null) {
                this.$state.go('home.cart');
                this.$timeout(() => {
                  this.$state.reload();
                }, 500);
                this.showModalAllMessage(allMessage);
              }
            }
          });
        } catch (e) {
        }

      } else {
        console.log('ocurrio un error al cambiar de sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }

  showModalAllMessage(allMesagge) {
    let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

    for (let i = 0; i < allMesagge.length; i++) {
      contentDynamic += `
                            <ul><li>` + allMesagge[i] + `</li></ul>`;
    }

    if (contentDynamic != '') {
      let optionsMessage = {
        title: 'Actualización de precios',
        isHtml: true,
        content: contentDynamic,
        size: '',
        showBottonCancel: false,
        textActionCancel: '',
        textAction: 'Aceptar',
        backdrop: 'static'
      };

      let modalInstance = this.$uibModal.open({
        animation: true,
        template: modalConfirmation,
        controller: 'ModalResponseController',
        controllerAs: 'mdCtrl',
        size: 'md',
        backdrop: 'static',
        resolve: {
          modalOptions: () => optionsMessage
        }
      });
      modalInstance.result.then(() => {
      }).catch(() => {

      });
    }
  }

  obtenerSucursalSecundaria(cartId, idCiudad, idUsuario) {
    let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
    };
    // Si la modalidad es recoge
    if (data != null) {
      this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
          if (this.branchUserB2B != idSucursalSecundaria) {
            this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, cartId);
          } else {
            this.$state.go('home.cart');
            this.$timeout(() => {
              this.$state.reload();
            }, 500);
            this.ok();
            let mesaggeChange = this.shCtrl.globalParams.cmsInfo.MENSAJE_CAMBIO_SUCURSAL;
            if (mesaggeChange !== '') {
              mesaggeChange = mesaggeChange;
              let optionsMessage = {
                title: 'Notificación',
                isHtml: true,
                content: mesaggeChange,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(optionsMessage);
            }
          }
        }
      });
      this.CartService.updateDateCart(cartId).then(response => {
        return response;
      });
    }
  }

  setSucursalSecundariaSinModalidad(idSucursal, userId, cartId) {

    let mensajeCambioSucursal = '';
    let allMessage = [];
    try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      allMessage.push(mensajeCambioSucursal);
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
        // Set the current client
        try {
          let newCurrentClient = JSON.parse(global.localStorage.currentClient);
          newCurrentClient.operatingCenter = response.branch;
          newCurrentClient.seller = response.seller;
          this.SessionService.put('currentClient', newCurrentClient);
          this.SessionService.put('cartId', response.cartID);

          this.$rootScope.$broadcast('actualizarHeader', response.branch);
          this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
            if (!response.error) {
              if (allMessage !== null) {
                this.$state.go('home.cart');
                this.$timeout(() => {
                  this.$state.reload();
                }, 500);
                this.showModalAllMessage(allMessage);
              }
            }
          });
        } catch (e) {
        }

      } else {
        console.log('Ocurrio un erro al cambiar la sucursal')
      }
    }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
    });
  }
}

TemplatesController.$inject = inject;

export default TemplatesController;




/** WEBPACK FOOTER **
 ** ./www/components/templates/templates.controller.js
 **/